// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__XSjzU","productName":"Table_productName__2h7sH"};